<template>
    <div>
        <ValidationObserver ref="form">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                :validate-error="errors[0]"
                                v-model="filter.academic_year">
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('report_type')">
                        <multi-selectbox :allow-empty="false" :multiple="false"
                                         :options="responseTypeOptions"
                                         v-model="responseType"></multi-selectbox>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <processing-button @click="getReport" label="get_report"
                                       :processing="processing"></processing-button>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>
<script>
// Components
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";

// Services
import PromotionalProcessReportService from "@/services/PromotionalProcessReportService";

// Other
import ProcessingButton from "@/components/elements/ProcessingButton";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import qs from "qs";

export default {
    components: {
        AcademicYearsSelectbox,
        ProcessingButton,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            processing: false,
            filter: {},
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'},
            ],
            responseType:'page',
            reportName: this.$t('faculty_comparison_report')
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.form.validate();
            if (isValid) {
                this.processing = true;
                let config = {
                    params: {
                        ...this.filter,
                        response_type: this.responseType,
                        page: -1
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                if(this.responseType!='page'){
                    config.responseType = 'arraybuffer';
                }

                PromotionalProcessReportService.facultyComparisonReport(config)
                    .then(this.callback)
                    .catch(e=>this.showErrors(e))
                    .finally(() => {
                        this.processing = false;
                    })
            }
        },
        callback(response) {
            if (this.responseType == 'page') {
                this._openFile(response);
            }
            else if (this.responseType == 'excel') {
                this._downloadFile(response, this.reportName + '.xlsx');
            }
            else if (this.responseType == 'pdf') {
                this._downloadFile(response, this.reportName + '.pdf');
            }
        }
    }
}
</script>
